import 'smoothstate/src/jquery.smoothState.js';

export default function () {

  /*

  // Smooth State
  var options = {
    prefetch: true,
    cacheLength: 2,
    onStart: {
      duration: 250, // Duration of our animation
      render: function ($container) {
        // Add your CSS animation reversing class
        $container.addClass('is-exiting');

        // Restart your animation
        smoothState.restartCSSAnimations();
      }
    },
    onReady: {
      duration: 0,
      render: function ($container, $newContent) {
        // Remove your CSS animation reversing class
        $container.removeClass('is-exiting');

        // Inject the new content
        $container.html($newContent);

      }
    }
  },
  smoothState = $('#site-wrapper').smoothState(options).data('smoothState');

  // SVG Loader
  var stroke = 500,
      $window = $(window),
      $rectangle = $('.loading__rectangle');

  function setStroke(){
      var t = $window.width(),
          e = $window.height(),
          n = 2 * t + 2 * e,
          i = stroke,
          o = n - i;

      $rectangle.css({
          'stroke-dasharray': i + " " + o,
          'stroke-dashoffset': n
      });
  }

  setStroke();
  $window.on('resize', setStroke);

  */

}


// WEBPACK FOOTER //
// ./scripts/components/SetupPageTransitions.js